import { LitElement, html, css } from 'lit'
import { ifDefined } from 'lit/directives/if-defined.js'

import styleUrl from '../../css/styles.css?url'

class HedeliusButton extends LitElement {
    static properties = {
        flex: { type: Boolean },
        icon: { type: Object },
        href: { type: String },
        blank: { type: Boolean },
        alignment: { type: String },
        download: { type: String },
    }

    constructor() {
        super()
        this.flex = true
        this.icon = null
        this.href = '#'
        this.blank = false
        this.alignment = 'justify-start'
        this.download = ''
    }

    static styles = css`
        :host {
            display: flex;
            flex: 1;
            height: inherit;
        }
    `

    _getClasses() {
        const classes = [
            'flex',
            'items-center',
            'gap-3',
            'leading-none',
            'px-4 py-[0.5rem]',
            this.alignment,
            this.flex ? 'flex-1' : '',
        ]
        return classes.filter(Boolean).join(' ')
    }

    render() {
        return html`
            <link rel="stylesheet" href="${styleUrl}" />

            <a
                class="${this._getClasses()}"
                href="${this.href}"
                target="${ifDefined(this.blank ? '_blank' : undefined)}"
                download="${ifDefined(this.download || undefined)}"
            >
                ${this.icon ? this.icon : ''}
                <slot></slot>
            </a>
        `
    }
}

customElements.define('hedelius-button', HedeliusButton)
